import { identify, Identify, init, setUserId, track } from "@amplitude/analytics-browser";
import { ScopeEnum, User } from "../client/api";
import { isInsider, isLocalDev } from "./utils";

const { version } = require("../../package.json");

let amplitudeUser: User | undefined;

export function initAmplitude(user: User) {
  if (!amplitudeUser) {
    amplitudeUser = user;
    init(
      "613384ef594094bf7fd1a84e7c9554cf",
      user.id.toString(10).padStart(6, "0"),
      {
        serverZone: "EU",
        autocapture: false,
        appVersion: version
      }
    );
    const id = new Identify();
    id.set("isRegistered", !user.anonymous);
    id.set(
      "isRegisteredVerified",
      !!user.scopes.find(s => s.key === ScopeEnum.REGISTERED)
    );
    id.set("isInsider", isInsider(user));
    id.set("isPlayer", !!user.playerId);
    id.set("province", user.areaOfInterest.key);
    id.set("region", user.areaOfInterest.regionId);
    id.set("pro", user.pro);
    id.set("hasProfilePic", !!user.photo);
    id.set("language", user.language.locale);
    identify(id);
  } else {
    const regVerified = !!user.scopes.find(s => s.key === ScopeEnum.REGISTERED);
    const regVerifiedPref = !!amplitudeUser.scopes.find(
      s => s.key === ScopeEnum.REGISTERED
    );
    const insider = !!user.scopes.find(s => s.key === ScopeEnum.REGISTERED);
    const insiderPref = !!amplitudeUser.scopes.find(
      s => s.key === ScopeEnum.REGISTERED
    );
    if (
      user.anonymous !== amplitudeUser.anonymous ||
      user.playerId !== amplitudeUser.playerId ||
      user.areaOfInterest.key !== amplitudeUser.areaOfInterest.key ||
      user.pro !== amplitudeUser.pro ||
      !!user.photo !== !!amplitudeUser.photo ||
      user.language.locale !== amplitudeUser.language.locale ||
      regVerified !== regVerifiedPref ||
      insider !== insiderPref
    ) {
      if (user.id !== amplitudeUser.id) {
        setUserId(user.id.toString(10).padStart(6, "0"));
      }
      const id = new Identify();
      id.set("isRegistered", !user.anonymous);
      id.set(
        "isRegisteredVerified",
        !!user.scopes.find(s => s.key === ScopeEnum.REGISTERED)
      );
      id.set("isInsider", isInsider(user));
      id.set("hasProfilePic", !!user.photo);
      id.set("isPlayer", !!user.playerId);
      id.set("region", user.areaOfInterest.regionId);
      id.set("province", user.areaOfInterest.key);
      id.set("pro", user.pro);
      id.set("language", user.language.locale);
      identify(id);
    }
  }
}

export function trackAmplitude(
  event: string,
  eventProperties?: Record<string, any>
) {
  if (isLocalDev()) {
    console.log(
      "\x1b[32m%s\x1b[0m",
      `Amplitude: ${event} ${JSON.stringify(eventProperties)}`
    );
  }
  track(event, eventProperties);
}
